import type { SessionResponse } from "@frontier/protocol/contracts";
import type { PlatformAuthAdapter } from "./platform-session";
import { api } from "./session-api";
import { initializeVkGamesSdk, readVkGamesDisplayName } from "./vkgames-sdk";

export class VkGamesAuthAdapter implements PlatformAuthAdapter {
  readonly provider = "vkgames";
  readonly hasLaunchProof: boolean;
  readonly messages = {
    missingProof: "Перезапусти игру через ВКонтакте, чтобы подтвердить вход.",
    foreignSession: "Открой игру через ВКонтакте, чтобы подтвердить пилота.",
    unconfirmedIdentity: "ВКонтакте не подтвердил пилота. Повтори подключение.",
  };

  constructor(
    private readonly launchParams: string,
    private readonly requests: Pick<typeof api, "vkGamesSession"> = api,
    private readonly initializeSdk: () => Promise<void> = initializeVkGamesSdk,
    private readonly readDisplayName: () => Promise<
      string | undefined
    > = readVkGamesDisplayName,
  ) {
    this.hasLaunchProof = launchParams.length > 0;
  }

  initialize(): Promise<void> {
    return this.initializeSdk();
  }

  async exchange(guestToken?: string): Promise<SessionResponse> {
    const displayName = await Promise.resolve()
      .then(() => this.readDisplayName())
      .catch(() => undefined);
    return this.requests.vkGamesSession(
      this.launchParams,
      guestToken,
      displayName,
    );
  }

  continueLogin(): Promise<void> {
    return Promise.reject(new Error(this.messages.missingProof));
  }
}
